import { useState } from "react";
import Layout from "../components/layouts/main";
import MintInfoChart from "../components/charts/MintInfoChart";
import { Flex, Spinner, Box } from "@chakra-ui/react";
import useMintInfo from "../hooks/useMintInfo";

const InfoPage = () => {
	const { data, loading } = useMintInfo();
	const [updateLoading, setUpdateLoading] = useState(true);
	// const [farmingLoading, setFarmingLoading] = useState(true);
	// const [holdingLoading, setHoldingLoading] = useState(true);
	const [updatesInfo, setUpdatesInfo] = useState([]);
	// const [farmingInfo, setFarmingInfo] = useState([]);
	// const [holdingInfo, setHoldingInfo] = useState([]);

	// useEffect(() => {
	// 	const fetchMintInfo = async () => {
	// 		setLoading(true);
	// 		try {
	// 			const response = await api.get('/mint-info');
	// 			setData(response.data);
	// 		} catch (error) {
	// 			console.error('Error fetching mint info:', error);
	// 		} finally {
	// 			setLoading(false);
	// 		}
	// 	};

	// 	fetchMintInfo();
	// }, []);

	// useEffect(() => {
	// 	const fetchUpdatesInfo = async () => {
	// 		setUpdateLoading(true);
	// 		try {
	// 			const response = await api.get('/mint-info');
	// 			setUpdatesInfo(response.data);
	// 		} catch (error) {
	// 			console.error('Error fetching updates info:', error);
	// 		} finally {
	// 			setUpdateLoading(false);
	// 		}
	// 	};

	// 	fetchUpdatesInfo();
	// }, []);

	// useEffect(() => {
	// 	const fetchFarmingUpdatesInfo = async () => {
	// 		setUpdateLoading(true);
	// 		try {
	// 			const response = await api.get('/farming/updates-by-day');
	// 			setFarmingInfo(response.data);
	// 		} catch (error) {
	// 			console.error('Error fetching updates info:', error);
	// 		} finally {
	// 			setFarmingLoading(false);
	// 		}
	// 	};

	// 	fetchFarmingUpdatesInfo();
	// }, []);

	// useEffect(() => {
	// 	const fetchHoldingUpdatesInfo = async () => {
	// 		setUpdateLoading(true);
	// 		try {
	// 			const response = await api.get('/holding/updates-by-day');
	// 			setHoldingInfo(response.data);
	// 		} catch (error) {
	// 			console.error('Error fetching updates info:', error);
	// 		} finally {
	// 			setHoldingLoading(false);
	// 		}
	// 	};

	// 	fetchHoldingUpdatesInfo();
	// }, []);

	return (
		<Layout>
			<Flex
				direction="column"
				align="center"
				justify="center"
				w="100%"
				maxW="700px"
				p={4}
				mx="auto"
			>
				{loading ? (
					<Flex justifyContent={"center"} alignItems={"center"} h="100vh">
						<Spinner color="orange" size="xl" />
					</Flex>
				) : (
					<>
						<Box w="100%" h="400px" mb={1}>
							<MintInfoChart data={data} />
						</Box>
						<p>Total Mints: {data.length}</p>
					</>
				)}

				{/* {updateLoading ? <Flex justifyContent={"center"} alignItems={"center"} h="100vh">
					<Spinner color="orange" size="xl" />
				</Flex> :
					<Box w="100%" h="400px" mb={1} pt={4}>
						<UpdatesByDayChart updatesInfo={updatesInfo} name={"Addresses Marks Updated By Day"} />
					</Box>
				} */}

				{/* {farmingLoading ? <Flex justifyContent={"center"} alignItems={"center"} h="100vh">
					<Spinner color="orange" size="xl" />
				</Flex> :
					<Box w="100%" h="400px" mb={1} pt={4}>
						<UpdatesByDayChart updatesInfo={farmingInfo} name={"Addresses Farming Updated By Day"} />
					</Box>
				} */}

				{/* {holdingLoading ? <Flex justifyContent={"center"} alignItems={"center"} h="100vh">
					<Spinner color="orange" size="xl" />
				</Flex> :
					<Box w="100%" h="400px" mb={1} pt={4}>
						<UpdatesByDayChart updatesInfo={holdingInfo} name={"Addresses Holding Updated By Day"} />
					</Box>
				} */}
			</Flex>
		</Layout>
	);
};

export default InfoPage;
